var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gfu-scroll-wrapper _flexcol _gap-2" }, [
    _c("div", { staticClass: "gfu-scroll-section" }, [
      _c("div", { staticClass: "_flex _-mx-2" }, [
        _c(
          "div",
          { staticClass: "_px-2" },
          [
            _vm._t("prefix"),
            _vm._v(" "),
            _vm.hasMoreThanOneTag
              ? _c(
                  "nav",
                  { class: _vm.tagsNavigationClasses },
                  _vm._l(_vm.mappedTags, function (tag) {
                    return _c(
                      "base-tab",
                      {
                        key: tag.key,
                        attrs: {
                          tag: "a",
                          href: tag.url,
                          title: tag.label,
                          variant: "link",
                          "is-active": tag.isActive,
                          "data-qa": `explore-tag:${tag.label}`,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onTagClick(tag.key)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tag.label) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.hasButtonNavigation
        ? _c(
            "div",
            { class: _vm.navigationWrapperClasses },
            [
              _c(
                "base-button",
                {
                  staticClass: "_ba-0",
                  attrs: {
                    theme: "white",
                    shape: "circle",
                    shadow: "tight",
                    disabled: _vm.isScrollLeftDisabled,
                    "data-qa": "left-arrow-button",
                  },
                  on: { click: _vm.onScrollLeft },
                },
                [
                  _c("base-icon", {
                    staticClass: "_tc--accent",
                    attrs: { name: "chevron-left", size: "lg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "_ba-0",
                  attrs: {
                    theme: "white",
                    shape: "circle",
                    shadow: "tight",
                    disabled: _vm.isScrollRightDisabled,
                    "data-qa": "right-arrow-button",
                  },
                  on: { click: _vm.onScrollRight },
                },
                [
                  _c("base-icon", {
                    staticClass: "_tc--accent",
                    attrs: { name: "chevron-right", size: "lg" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.scrollContainerWrapperClasses }, [
      _c(
        "div",
        { ref: "scrollContainer", class: _vm.effectiveScrollContainerClasses },
        [
          !_vm.isProcessing && _vm.hasItems
            ? [
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.props.key,
                      class: _vm.cardWrapperClasses,
                      attrs: { "data-qa": item.props.dataQa },
                    },
                    [
                      _vm._t(
                        "slide",
                        function () {
                          return [
                            _c(
                              item.component,
                              _vm._b(
                                {
                                  tag: "component",
                                  class: item.props.slideClasses,
                                },
                                "component",
                                item.props,
                                false
                              )
                            ),
                            _vm._v(" "),
                            item.customItemComponent
                              ? _c(
                                  item.customItemComponent,
                                  _vm._b(
                                    {
                                      tag: "component",
                                      class:
                                        item.customItemComponentProps
                                          .slideClasses,
                                    },
                                    "component",
                                    item.customItemComponentProps,
                                    false
                                  )
                                )
                              : _vm._e(),
                          ]
                        },
                        { item: item }
                      ),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.canLoadMoreRows
                  ? [
                      _c(
                        "intersection-trigger",
                        {
                          attrs: {
                            root: _vm.$refs.scrollContainer,
                            "root-margin": `0px 0px 0px 0px`,
                            threshold: 0,
                          },
                          on: { intersected: _vm.onIntersected },
                        },
                        _vm._l(_vm.placeholders, function (placeholder) {
                          return _c(
                            "div",
                            { key: placeholder, class: _vm.cardWrapperClasses },
                            [
                              _vm._t("placeholder", function () {
                                return [
                                  _c("skeleton-card", {
                                    staticClass: "_h-full",
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._l(_vm.placeholders, function (placeholder) {
                return _c(
                  "div",
                  { key: placeholder, class: _vm.cardWrapperClasses },
                  [
                    _vm._t("placeholder", function () {
                      return [_c("skeleton-card", { staticClass: "_h-full" })]
                    }),
                  ],
                  2
                )
              }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.currentTag && _vm.currentTag.url
      ? _c(
          "div",
          { staticClass: "_flex _jc-fe" },
          [
            _c(
              "base-link",
              {
                staticClass: "gfu-link gfu-link--accent",
                attrs: {
                  url: _vm.currentTag.url,
                  title: _vm.currentTag.actionLabel,
                  "data-qa": `view-projects-button:${_vm.currentTag.actionLabel}`,
                },
                on: { click: _vm.onViewAllClick },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.currentTag.actionLabel) +
                    "\n            "
                ),
                _c("base-icon", { attrs: { name: "chevron-right" } }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }